export default __webpack_public_path__ + "static/media/safety.c78cc644.png";